import React, { useState, useEffect } from "react";
import { Button, Row, Col } from "reactstrap";
import { Form, Modal } from "react-bootstrap";
import captchImg from "../../assets/images/captchaImg.jpg";
import Slider from "react-slick";
import imageNotAvailable from "../../assets/img/Image_not_available.png"
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { useNavigate } from "react-router-dom";
import axiosConn from "config/axiosConn";
import { jwtDecode } from "jwt-decode";
import SideBar from "./SideBar";
import Langfield from "../../assets/Json/accountFormLang.json";
import Helper from "../../helper/Common_Helper";
import { changeLang, voiceSelected } from "../../redux/langSlice";
import { useDispatch } from "react-redux";
import { GiConsoleController } from "react-icons/gi";
import { useSelector } from "react-redux";
import StateList from "../../helper/State_List.json";
import DistrictList from "../../helper/District_List.json";

function EventList() {
  const navigate = useNavigate();
  const [modalShow, setModalShow] = useState(false);
  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const [themeList, setThemeList] = useState([]);
  const [statusValue, setStatus] = useState(1);
  const [role, setRole] = useState("");
  const [auther, setAuther] = useState("");
  const [mediaUrl, setMediaUrl] = useState("");
  const [isVideo, setIsVideo] = useState(false);
  const [voiceSelected, setVoiceSelected] = useState("");
  const [udise_id, setUDISE] = useState("");
  const [username, setUserName] = useState("");
  const [email, setEmail] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [initialValues, setInitialValues] = useState({
    udise_id: "",
  });
  const userData = useSelector(state => state.auth.user);
  const langSelected = userData.lang;
  const dispatch = useDispatch();
  const translations = Langfield[langSelected];

  const readOnlySasToken = "sp=racwl&st=2025-04-01T07:46:42Z&se=2025-07-31T15:46:42Z&spr=https&sv=2024-11-04&sr=c&sig=w%2BL9zU%2Fp35vjnI5P1Aghw%2B%2BB1zMW%2B7lI6XkGMPNhCD0%3D";

  const translate = (key) => {
    // Check if translations is defined and is an object
    if (typeof translations !== "object" || translations === null) {
      return key; // Return the key if translations is not available
    }

    // Handle undefined or non-string keys
    if (typeof key !== "string") {
      return key; // Return the value as is if key is not a string
    }

    return translations[key] || key.replace(/_/g, " "); // Use translation or fallback to the key
  };

  // Helper function to get district name from district ID
  const getDistrictName = (districtId) => {
    if (!districtId) return "";

    // Handle both string and number district IDs
    const district = DistrictList.find(d => d.district_id == districtId);
    return district ? district.district_name : districtId;
  };

  // Helper function to get state name from state ID
  const getStateName = (stateId) => {
    if (!stateId) return "";

    // Handle both string and number state IDs
    const state = StateList.find(s => s.state_id == stateId);
    return state ? state.state_name : stateId;
  };

  useEffect(() => {
    if (userData) {
      // console.log("userData", userData);	
      setRole(userData.role);
      setUDISE(userData.udise_id);
      setInitialValues({
        ...initialValues,
        ["udise_id"]: userData.udise_id,
      });
      // getLanguageFunction({ udise_id: userData.udise_id });
      setAuther(userData?.email ? userData?.email : "Principal");
      if (userData.role === 2) {
        getThemeList({
          udise_id: userData.udise_id,
          isdeleted: false,
          status: statusValue,
        });
      } else {
        setEmail(userData.email);
        // setUserName(auth.username);
        getFacultyThemeList({
          udise_id: userData.udise_id,
          email: userData.email,
          status: statusValue,
        });
      }
    } else {
      navigate("/");
    }
  }, [userData]);





  const handleChanges = (val) => {
    setStatus(val);
    if (role === 2) {
      getThemeList({ udise_id: udise_id, isdeleted: false, status: val });
    } else {
      getFacultyThemeList({
        udise_id: udise_id,
        email: email,
        isdeleted: false,
        status: val,
      });
    }
  };

  const getThemeList = async (data, page = 1) => {
    try {
      data["page"] = page;
      data["limit"] = 9;

      const response = await axiosConn("post", `get-themes`, data, {}, dispatch);
      // console.log("response:22", response);
      if (response.data.status === "success") {
        if (response.data.data.length > 0) {
          setThemeList(response.data.data);
          setTotalPages(response.data.totalPages);
          setCurrentPage(response.data.currentPage);
        } else {
          setThemeList([]);
        }
      } else {
        setThemeList([]);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const handlePageChange = (page) => {
    if (page > 0 && page <= totalPages) {
      setCurrentPage(page);
      if (role === 2) {
        getThemeList({ udise_id, isdeleted: false, status: statusValue }, page);
      } else {
        getFacultyThemeList(
          {
            udise_id: udise_id,
            isdeleted: false,
            email: email,
            status: statusValue,
          },
          page
        );
      }
    }
  };

  const getThemeById = async (id) => {
    try {
      const response = await axiosConn("get", `get-theme/${id}`);
      if (response.data.status === "success") {
        return response.data.data;
      } else {
        console.error("Theme not found");
        return null;
      }
    } catch (error) {
      console.error("Error fetching theme by ID:", error);
      return null;
    }
  };

  const getFacultyThemeList = async (data, page = 1) => {
    try {
      data["page"] = page;
      data["limit"] = 9;
      const response = await axiosConn(
        "post",
        `get-faculty-assigned-event`,
        data
      );
      if (response.data.status === "success") {
        if (response.data.data.length > 0) {
          setThemeList(response.data.data);
          setTotalPages(response.data.totalPages);
          setCurrentPage(response.data.currentPage);
        } else {
          setThemeList([]);
        }
      } else {
        setThemeList([]);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const updateTheme = async (data) => {
    try {
      data["auther"] = auther;
      const response = await axiosConn("post", `action-approve-delete`, data);
      if (response.data.status === "success") {
        if (role === 2) {
          getThemeList({
            udise_id: udise_id,
            isdeleted: false,
            status: statusValue,
          });
        } else {
          getFacultyThemeList({
            udise_id: udise_id,
            email: email,
            isdeleted: false,
            status: statusValue,
          });
        }
      }
    } catch (error) {
      console.log(error);
    }
  };

  const settings = {
    dots: false,
    infinite: false,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 3,
    initialSlide: 0,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
          infinite: true,
          dots: true,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
          initialSlide: 2,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };

  const handleMediaClick = (url, type) => {
    setMediaUrl(url);
    setIsVideo(type === "video");
    setModalShow(true);
  };

  const handleEditClick = async (item) => {
    const themeDetails = await getThemeById(item._id);
    if (themeDetails) {
      navigate("/school/eventmanagement", {
        state: { item: themeDetails },
      });
    }
  };

  return (
    <>
      <Modal show={show} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title>Report an Image</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="reportImgDiv">
            <form action="">
              <div className="form-group">
                <label htmlFor="">Remarks</label>
                <textarea
                  name=""
                  id=""
                  cols="30"
                  rows="10"
                  className="form-control"
                ></textarea>
              </div>
              <div className="form-group">
                <label htmlFor="">Security Pin</label>
                <img src={captchImg} alt="" />
              </div>
            </form>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="primary"
            className="button green btn-login-signup loginBtnnewhm reprtBtn"
            onClick={handleClose}
          >
            Submit
          </Button>
        </Modal.Footer>
      </Modal>

      <section className="scholdashbrdSec eventListSecnew">
        <SideBar langSelected={langSelected} index={3} role={role} />

        <div className="schlDashbrdRgt">
          <div class="row justify-content-center">
            <div class="col-md-12">
              <div class="card-user pageContainer">
                <div class="card-header pgHederSpceArnd">
                  <h5 class="card-title">{translate("Event List")}</h5>
                </div>
                <div className="">
                  <div className="container">
                    <Row>
                      <Col md="12">
                        <div className="d-flex justify-content-center w-100 mb-4">
                          <div
                            className="d-flex justify-content-start mr-5"
                            style={{ marginRight: "15px" }}
                          >
                            <Form.Check
                              name="status"
                              value="1"
                              style={{ marginRight: "5px" }}
                              type="radio"
                              defaultChecked
                              onClick={() => handleChanges(1)}
                            ></Form.Check>
                            <Form.Label className="ml-2">
                              {translate("Pending")}
                            </Form.Label>
                          </div>
                          <div
                            className="d-flex justify-content-start mr-5"
                            style={{ marginRight: "15px" }}
                          >
                            <Form.Check
                              name="status"
                              value="2"
                              style={{ marginRight: "5px" }}
                              type="radio"
                              onClick={() => handleChanges(2)}
                            ></Form.Check>
                            <Form.Label className="ml-2">
                              {translate("Approved")}
                            </Form.Label>
                          </div>
                          <div
                            className="d-flex justify-content-start mr-5"
                            style={{ marginRight: "15px" }}
                          >
                            <Form.Check
                              name="status"
                              value="0"
                              style={{ marginRight: "5px" }}
                              type="radio"
                              onClick={() => handleChanges(0)}
                            ></Form.Check>
                            <Form.Label className="ml-2">
                              {translate("Rejected")}
                            </Form.Label>
                          </div>
                        </div>
                      </Col>
                      {themeList && themeList.length > 0 ? (
                        themeList.map((item, i) => {
                          const media = [
                            ...(item.photos || []).map((pics) => ({
                              type: "image",
                              url: pics,
                            })),
                            ...(item.videos || []).map((vid) => ({
                              type: "video",
                              url: vid,
                            })),
                          ];

                          const getSecurePhotoUrl = (photos, sasToken) => {
                            if (!photos || photos.length === 0) return null;
                            const fullUrl = photos[0]?.photo_url || (typeof photos[0] === 'string' ? photos[0] : null);
                            if (!fullUrl) return null;

                            const baseUrl = fullUrl.split('?')[0]; // Strip any existing token
                            return `${baseUrl}?${sasToken}`;       // Attach your custom token
                          };

                          const rawPhotoUrl = item.photos?.[0]?.photo_url || (typeof item.photos?.[0] === 'string' ? item.photos[0] : null) || item.img_files?.[0] || item.attachment;
                          const securePhotoUrl = rawPhotoUrl ? `${rawPhotoUrl.split('?sp')[0]}?sp=r&st=2026-02-06T06:00:58Z&se=2026-12-31T14:15:58Z&spr=https&sv=2024-11-04&sr=c&sig=n4zcC%2FICuzy6IgQ62mGtREv%2FQI3HUeu2TFULEdZkDyI%3D` : null;

                          const isPledgeEvent = item.event_name === "Pledge" && item.theme_name === "Adopt Healthy Lifestyles";

                          return (
                            <Col md="4" key={i}>
                              <div className={`viewThemeDiv ${isPledgeEvent ? 'pledge-special-card' : ''}`}>
                                <div className="flip-card">
                                  <div className="flip-card-inner">
                                    <div className={`${securePhotoUrl ? 'flip-card-front2' : 'flip-card-front'} ${isPledgeEvent ? 'pledge-front' : ''}`}>
                                      <div className="flip-card-front-in">
                                        {securePhotoUrl ? (
                                          <img
                                            src={securePhotoUrl}
                                            alt="Image not Uploaded"
                                          />
                                        ) : isPledgeEvent ? (
                                           <div className="pledge-placeholder">
                                              <span className="eco-icon-large">🌱</span>
                                              <h3>Adopt Healthy Lifestyles</h3>
                                              <p>Pledge Participation Activity</p>
                                           </div>
                                        ) : (
                                          <img
                                            src={imageNotAvailable}
                                            alt="Image not Uploaded"
                                          />
                                        )}
                                        <div className="frontThemName">
                                          <h1>
                                            {isPledgeEvent ? "🌱 " : ""}
                                            {translate("Event Name")} :
                                            <strong>
                                              {item.event_name && item.event_name.length > 50
                                                ? item.event_name.substring(0, 50) + "..."
                                                : item.event_name}
                                              {item.number_events > 1 && item.event_index && (
                                                <span style={{ fontSize: '0.85em', color: '#555', fontWeight: 'normal', marginLeft: '8px', background: '#eee', padding: '2px 6px', borderRadius: '4px' }}>
                                                  #{item.event_index}
                                                </span>
                                              )}
                                            </strong>
                                          </h1>
                                        </div>
                                      </div>
                                    </div>
                                    <div className={`flip-card-back ${isPledgeEvent ? 'pledge-back' : ''}`}>
                                      <div className="flipCardBackIn">
                                        <h1>
                                          {translate("Event Name")} :
                                          <strong>
                                            {item.event_name ? item.event_name : ""}
                                            {isPledgeEvent && " 🌱🌍♻️"}
                                          </strong>
                                        </h1>
                                        <h1>
                                          {translate("Theme Name")}:
                                          <strong>
                                            {item.theme_name ? item.theme_name : ""}
                                          </strong>
                                        </h1>
                                        {isPledgeEvent && (
                                          <h1>
                                            School Name:
                                            <strong>{item.school_name}</strong>
                                          </h1>
                                        )}
                                        <h1>
                                          {translate("Event Description")}:
                                          <strong>
                                            {item.desc ? item.desc : ""}
                                          </strong>
                                        </h1>
                                        <h1>
                                          {translate("Sub Theme")}:
                                          <strong>
                                            {item.sub_themes[0] ? item.sub_themes[0] : ""}
                                          </strong>
                                        </h1>
                                        <h1>
                                          {translate("Event Date")}:
                                          <strong>
                                            {item.event_date ? Helper.formatDate(item.event_date) : ""}
                                          </strong>
                                        </h1>
                                        <h1>
                                          {translate("Mode of Implementation")}:
                                          <strong>
                                            {item.implemnt_mode ? item.implemnt_mode : ""}
                                          </strong>
                                        </h1>
                                        <h1>
                                          {translate("Type of Event")}:
                                          <strong>
                                            {item.event_type ? item.event_type : ""}
                                          </strong>
                                        </h1>
                                        <h1>
                                          {translate("Number of Event")}:
                                          <strong>
                                            {item.number_events ? item.number_events : ""}
                                          </strong>
                                        </h1>
                                        <h1>
                                          {translate("technological intervention?")}
                                          <strong>
                                            {item.isEventTechIntervention ? item.isEventTechIntervention : ""}
                                          </strong>
                                        </h1>
                                        <h1>
                                          {translate("Have All Participants Attending Event Taken The Pledge?")}
                                          <strong>
                                            {item.haveParticipantPledge ? item.haveParticipantPledge : ""}
                                          </strong>
                                        </h1>
                                        <h1>
                                          {translate("Total Participants")}:
                                          <strong>
                                            {item?.number_participant_age8to11 +
                                              item?.number_participant_age14to18 +
                                              item?.number_participant_age11to14 +
                                              item?.number_participant_age3to8 +
                                              item?.number_participant_age18plus}
                                          </strong>
                                        </h1>
                                        {isPledgeEvent && (
                                           <div className="pledge-participation-breakdown">
                                              <p>Teachers: {item.number_participant_age18plus}</p>
                                              <p>Students: {item.number_participant_age14to18}</p>
                                           </div>
                                        )}
                                        <h1>
                                          {translate("State")}:
                                          <strong>
                                            {getStateName(item.state) || item.state || ""}
                                          </strong>
                                        </h1>
                                        <h1>
                                          {translate("District")}:
                                          <strong>
                                            {getDistrictName(item.district) || item.district || ""}
                                          </strong>
                                        </h1>
                                        <h1>
                                          {translate("City")}:
                                          <strong>
                                            {item.city ? item.city : ""}
                                          </strong>
                                        </h1>
                                        {item.photo_caption && (
                                          <h1>
                                            {translate("Photo Caption")}:
                                            <strong>
                                              {item.photo_caption ? item.photo_caption : ""}
                                            </strong>
                                          </h1>
                                        )}
                                        {item.video_caption && (
                                          <h1>
                                            {translate("Video Caption")}:
                                            <strong>
                                              {item.video_caption ? item.video_caption : ""}
                                            </strong>
                                          </h1>
                                        )}
                                      </div>
                                    </div>
                                  </div>

                                  <div className="themCarslDiv">
                                    <Slider {...settings}>
                                      {/* {console.log} */}
                                      {media.map((mediaItem, j) => (
                                        <div className="slide01newnew" key={j}>
                                          <div
                                            className="btn-login-signup"
                                            onClick={() =>
                                              handleMediaClick(
                                                mediaItem.type === "image" ? `${mediaItem?.url?.photo_url?.split('?sp')[0]}?sp=r&st=2026-02-06T06:00:58Z&se=2026-12-31T14:15:58Z&spr=https&sv=2024-11-04&sr=c&sig=n4zcC%2FICuzy6IgQ62mGtREv%2FQI3HUeu2TFULEdZkDyI%3D` : `${mediaItem?.url?.split('?sp')[0]}?sp=r&st=2026-02-06T06:00:58Z&se=2026-12-31T14:15:58Z&spr=https&sv=2024-11-04&sr=c&sig=n4zcC%2FICuzy6IgQ62mGtREv%2FQI3HUeu2TFULEdZkDyI%3D`,
                                                mediaItem.type
                                              )
                                            }
                                          >
                                            {mediaItem.type === "image" ? (
                                              <img
                                                src={
                                                  `${mediaItem?.url?.photo_url?.split('?sp')[0]}?sp=r&st=2026-02-06T06:00:58Z&se=2026-12-31T14:15:58Z&spr=https&sv=2024-11-04&sr=c&sig=n4zcC%2FICuzy6IgQ62mGtREv%2FQI3HUeu2TFULEdZkDyI%3D`

                                                }
                                                alt="Slider Media"
                                              />
                                            ) : (
                                              <video
                                                style={{
                                                  width: "100%",
                                                  height: 71,
                                                }}
                                              >
                                                <source
                                                  src={
                                                    mediaItem.url
                                                  }
                                                  type="video/mp4"
                                                />
                                                Your browser does not support
                                                the video tag.
                                              </video>
                                            )}
                                          </div>
                                        </div>
                                      ))}
                                    </Slider>
                                  </div>
                                  {statusValue === 1 ? (
                                    <div className="actionBtn">
                                      <Button
                                        variant="primary"
                                        onClick={() => handleEditClick(item)}
                                        className="btn-round btn btn-primary apprvBtn mr-3"
                                      >
                                        {translate("Edit")}
                                      </Button>

                                      {/* Check if item has photos or videos before rendering the "Approve" button */}
                                      {((item.photos.length > 0 ||
                                        item.videos.length > 0) && role !== 3) && (
                                          <Button
                                            variant="primary"
                                            onClick={() =>
                                              updateTheme({
                                                id: item._id,
                                                status: 2,
                                              })
                                            }
                                            className="btn-round btn btn-primary editBtn mr-3"
                                          >
                                            {translate("Approve")}
                                          </Button>
                                        )}
                                      {((item.photos.length > 0 ||
                                        item.videos.length > 0) && role !== 3) && (
                                          <Button
                                            variant="primary"
                                            onClick={() =>
                                              updateTheme({
                                                id: item._id,
                                                status: 0,
                                              })
                                            }
                                            className="btn-round btn btn-primary btnDelete mr-3"
                                          >
                                            {translate("Reject")}
                                          </Button>
                                        )}
                                    </div>
                                  ) : (
                                    <div className="actionBtn">
                                      <Button
                                        variant="primary"
                                        className="btn-round btn btn-primary apprvBtn mr-3"
                                        style={isPledgeEvent ? { backgroundColor: '#19861f', borderColor: '#19861f' } : {}}
                                      >
                                        {isPledgeEvent ? "Completed" : (item.status === 2
                                          ? translate("Approved")
                                          : item.status === 0
                                            ? translate("Rejected")
                                            : "")}
                                      </Button>
                                    </div>
                                  )}
                                </div>
                              </div>
                            </Col>
                          );
                        })
                      ) : (
                        <p className="text-center">Event not found.</p>
                      )}
                    </Row>
                    {totalPages > 1 ? (
                      <div className="mb-3 text-center">
                        <button
                          onClick={() => handlePageChange(currentPage - 1)}
                          disabled={currentPage === 1}
                        >
                          {translate("Previous")}
                        </button>
                        <span>
                          {`Page ${currentPage} of ${totalPages}`}
                        </span>
                        <button
                          onClick={() => handlePageChange(currentPage + 1)}
                          disabled={currentPage === totalPages}
                        >
                          {translate("Next")}
                        </button>
                      </div>
                    ) : (
                      ""
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <MyVerticallyCenteredModal
        show={modalShow}
        onHide={() => setModalShow(false)}
        mediaUrl={mediaUrl}
        isVideo={isVideo}
        setModalShow={(value) => {
          setModalShow(value);
        }}
      />
    </>
  );
}

export default EventList;

function MyVerticallyCenteredModal(props) {
  return (
    <Modal
      {...props}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
    >
      <span onClick={() => props.setModalShow(false)} className="closebtn">
        X
      </span>
      <Modal.Body style={{ padding: 20 }}>
        {props.isVideo ? (
          <video controls style={{ width: "100%", height: 500 }}>
            <source src={props.mediaUrl} type="video/mp4" />
            Your browser does not support the video tag.
          </video>
        ) : (
          <img src={props.mediaUrl} alt="" style={{ width: "100%" }} />
        )}
      </Modal.Body>
    </Modal>
  );
}
